export function formatContact(email: string, label: string | null): string {
	if (!label) {
		return email;
	}
	return `${label} (${email})`;
}
